var map = {
	"./cloudIcon-active.svg": 34633,
	"./cloudIcon0.svg": 60166,
	"./cloudIcon1.svg": 47703,
	"./cloudIcon2.svg": 4580,
	"./collectIcon-active.svg": 88758,
	"./collectIcon0.svg": 43525,
	"./collectIcon1.svg": 92356,
	"./collectIcon2.svg": 35479,
	"./historyIcon-active.svg": 62792,
	"./historyIcon0.svg": 57983,
	"./historyIcon1.svg": 29550,
	"./historyIcon2.svg": 77901,
	"./publishFileIcon-active.svg": 13473,
	"./publishFileIcon0.svg": 70334,
	"./publishFileIcon1.svg": 90383,
	"./publishFileIcon2.svg": 4412,
	"./sharetomeIcon-active.svg": 95804,
	"./sharetomeIcon0.svg": 94211,
	"./sharetomeIcon1.svg": 79570,
	"./sharetomeIcon2.svg": 72705,
	"./starFileIcon-active.svg": 88190,
	"./starFileIcon0.svg": 66861,
	"./starFileIcon1.svg": 19500,
	"./starFileIcon2.svg": 98527,
	"./trashIcon-active.svg": 90162,
	"./trashIcon0.svg": 90801,
	"./trashIcon1.svg": 92768,
	"./trashIcon2.svg": 37427
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 10278;